import * as React from "react"
import * as style from "./style.module.css"
import * as style2 from "/src/styles/foundation/template.module.css"
import ArticleList from "/src/components/ArticleList"
import BottomContact from "/src/components/BottomContact"
import Layout from "/src/components/Layout"
import MainButton from "/src/components/MainButton"
import Seo from "/src/components/Seo"
import KvTop from "/src/components/KvTop"
import KvTopImg from "/src/images/common/kv_common.jpg"
import CustomButton from "/src/components/CustomButton"
import topBusinessImg from "/src/images/top/top_business_img.jpg"
import topPointImg001 from "/src/images/top/top_point_img_001.jpg"
import topPointImg002 from "/src/images/top/top_point_img_002.jpg"
import topPointImg003 from "/src/images/top/top_point_img_003.jpg"
import topStaffImg001 from "/src/images/top/top_staff_img_001.jpg"
import topStaffImg002 from "/src/images/top/top_staff_img_002.jpg"
import topStaffImg003 from "/src/images/top/top_staff_img_003.jpg"
import topRecruitImg from "/src/images/top/top_recruit_img.jpg"
import topFlowImg from "/src/images/top/top_flow_img.jpg"
import topCompanyImg from "/src/images/top/top_company_img.jpg"
import { getPathFromTemplateType } from "/src/utils/getPathFromTemplateType"
import KvVideo from "/src/video/video_kv.mp4"

const Page = ({ pageContext }) => {
  return (
    <Layout>
      <KvTop
        text="建設とは、安心。<br />安心とは、信頼。<br />信頼とは、絆。"
        kvVideo={KvVideo}
      />

      <section className={style.topMessageSection}>
        <span>
          私たち株式会社新翔は、
          <br />
          安全な足場づくりと確かな実績を通じて、
          <br />
          人々の「絆」を紡ぐ会社です。
        </span>
      </section>

      <section className={style2.topBusinessSection}>
        <div className={style2.topBusinessWrapper}>
          <img src={topBusinessImg} alt="事業内容画像" />
          <div className={style2.topBusinessTextWrapper}>
            <h2>事業内容</h2>
            <p>
              一般低層住宅、中高層建築足場や特殊足場まで、
              <br />
              様々な足場に対応しています。
              <br />
              私たち株式会社新翔の豊富な経験と実績が、
              <br />
              これからの未来を築く私たちの街づくりに貢献しています。
            </p>
            <CustomButton inLink="/business" text="事業内容を見る" />
          </div>
        </div>
      </section>

      <section className={style.topPointSection}>
        <div className={style2.topPointWrapper}>
          <div className={style2.topPointTopWrapper}>
            <span>信頼</span>
            <img src={topPointImg001} alt="ポイント画像" />
          </div>
          <div className={style2.topPointBottomWrapper}>
            高所作業の安全をお約束します！
          </div>
        </div>

        <div className={style2.topPointWrapper}>
          <div className={style2.topPointTopWrapper}>
            <span>迅速</span>
            <img src={topPointImg002} alt="ポイント画像" />
          </div>
          <div className={style2.topPointBottomWrapper}>
            様々な足場工事にも
            <br />
            迅速対応いたします！
          </div>
        </div>

        <div className={style2.topPointWrapper}>
          <div className={style2.topPointTopWrapper}>
            <span>丁寧</span>
            <img src={topPointImg003} alt="ポイント画像" />
          </div>
          <div className={style2.topPointBottomWrapper}>
            顧客満足度120％を目指した丁寧な作業
          </div>
        </div>
      </section>

      <section className={style2.topBusinessSection}>
        <div className={`${style2.topBusinessWrapper} ${style2.left}`}>
          <img src={topRecruitImg} alt="採用情報画像" />
          <div className={style2.topBusinessTextWrapper}>
            <h2>採用情報</h2>
            <p>
              互いに切磋琢磨しながら、多くのお客様の今に触れ、
              <br />
              未来に繋がるサポートをしてまいりました。
              <br />
              お客様を照らす希望に満ちた未来と、当社が歩む明るい未来を、
              <br />
              共に力を合わせて紡いでいく存在。私たちはそんなあなたを、待っています。
            </p>
            <CustomButton inLink="/recruit" text="採用情報を見る" />
          </div>
        </div>
      </section>

      <section className={style2.topStaffSection}>
        <div className={style2.topStaffWrapper}>
        <h2 className={style.titleH2Staff}>社員紹介</h2>
          <div className={style2.topStaff}>
            <div className={style2.topPointTopWrapper}>
              <img src={topStaffImg001} alt="スタッフ画像" />
            </div>
            <div className={style2.topPointBottomWrapper}>
              働きやすい環境で、自分の長所を最大限に活かせる会社だと思います。
            </div>
          </div>

          <div className={style2.topStaff}>
            <div className={style2.topPointTopWrapper}>
              <img src={topStaffImg002} alt="スタッフ画像" />
            </div>
            <div className={style2.topPointBottomWrapper}>
              皆、親切で、仕事をしていても楽しくやっていっています。
            </div>
          </div>

          <div className={style2.topStaff}>
            <div className={style2.topPointTopWrapper}>
              <img src={topStaffImg003} alt="スタッフ画像" />
            </div>
            <div className={style2.topPointBottomWrapper}>
              ストレスフリーな状態で仕事ができる。
              <br />
              これが、本当に自分を成長させてくれるなと感じています。
            </div>
          </div>
          <div className={style2.topStaffBottomWrapper}>
          <CustomButton inLink="/staff" text="社員紹介を見る" />
        </div>
        </div>
      </section>

      <section className={style.third_section}>
        <div className={style.section_heading}>
          <h2 className={style.titleH2}>お知らせ</h2>
          <small>News</small>
          <div className={style.section_decoration}></div>
          <p className={style.section_description}>{pageContext.articleText}</p>
        </div>
        {pageContext.articles.length !== 0 ? (
          <>
            <div className={style.blog_items}>
              <ArticleList articles={pageContext.articles} />
            </div>
            <div className={style.topArticlesBottomWrapper}>
              <CustomButton inLink="/articles/p/1" text="お知らせ一覧" />
            </div>
          </>
        ) : (
          <div className={style.blog_textarea_empty}>
            <p>現在、記事は投稿されていません。</p>
          </div>
        )}
      </section>

      <section className={style2.topBusinessSection}>
        <div className={style2.topBusinessWrapper}>
          <img src={topFlowImg} alt="フロー画像" />
          <div className={style2.topBusinessTextWrapper}>
            <h2>取引の流れ</h2>
            <p>
              互いに切磋琢磨しながら、多くのお客様の今に触れ、<br />
              未来に繋がるサポートをしてまいりました。<br />
              お客様を照らす希望に満ちた未来と、当社が歩む明るい未来を、<br />
              共に力を合わせて紡いでいく存在。私たちはそんなあなたを、待っています。
            </p>
            <CustomButton inLink="/flow" text="取引の流れを見る" />
          </div>
        </div>
      </section>

      <section className={style.topCompanySection}>
        <div className={style.topCompanyLeftWrapper}>
          <table>
            <tr>
              <th>商号</th>
              <td>株式会社　新翔</td>
            </tr>
            <tr>
              <th>代表取締役</th>
              <td>新保　祐樹</td>
            </tr>
            <tr>
              <th>所在地</th>
              <td>
                〒241-0806<br />
                神奈川県横浜市旭区下川井町302-3
              </td>
            </tr>
            <tr>
              <th>電話番号</th>
              <td>
                045-744-5812
              </td>
            </tr>
            <tr>
              <th>FAX</th>
              <td>
              045-744-5812
              </td>
            </tr>
            <tr>
              <th>創業</th>
              <td>
                2006年9月
              </td>
            </tr>
            <tr>
              <th>創立</th>
              <td>
                2012年5月
              </td>
            </tr>
            <tr>
              <th>資本金</th>
              <td>
                500万円
              </td>
            </tr>
            <tr>
              <th>従業員数</th>
              <td>
                22人
              </td>
            </tr>
          </table>
        </div>
        <div className={style.topCompanyRightWrapper}>
          <img src={topCompanyImg} alt="トップ会社概要画像" />
        </div>
      </section>
    </Layout>
  )
}

export default Page

export const Head = ({ pageContext }) => {
  return <Seo pageContext={pageContext} />
}
